(() => {
  if (window.ftDesignGroupInstalled) return;
  window.ftDesignGroupInstalled = true;
  const name = value => String(value).trim().toLowerCase().replace(/^color$/, 'colour');
  function update(group) {
    const source = JSON.parse(group.querySelector('[data-design-source]').textContent);
    const scope = document.getElementById('shopify-section-' + group.dataset.section) || group.parentElement;
    const id = scope.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    const current = source.variants.find(v => String(v.id) === String(id));
    const choices = [];
    source.options.forEach((option, index) => {
      const key = name(typeof option === 'string' ? option : option.name);
      if (!['colour', 'size'].includes(key)) return;
      const input = Array.from(scope.querySelectorAll('select[name^="options["], input[name^="options["]:checked')).find(el => name(el.name.slice(8, -1)) === key);
      const value = input?.value ?? current?.options[index];
      if (value !== undefined) choices.push([key, value]);
    });
    group.querySelectorAll('[data-design-link]').forEach(link => {
      const target = JSON.parse(link.querySelector('[data-design-product]').textContent);
      const match = choices.length && target.variants.find(v => choices.every(([key, value]) => {
        const index = target.options.findIndex(o => name(typeof o === 'string' ? o : o.name) === key);
        return index >= 0 && v.options[index] === value;
      }));
      link.href = link.dataset.base + (match ? '?variant=' + match.id : '');
    });
  }
  document.addEventListener('change', () => setTimeout(() => document.querySelectorAll('[data-ft-design-group]').forEach(update), 0));
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-design-link]');
    if (link) update(link.closest('[data-ft-design-group]'));
  }, true);
})();
